(function () {
  const initRoutineFinder = (section) => {
    if (!section || section.dataset.rfBound === 'true') return;
    section.dataset.rfBound = 'true';

    const step1Buttons = Array.from(section.querySelectorAll('[data-rf-step1]'));
    const step2Buttons = Array.from(section.querySelectorAll('[data-rf-step2]'));
    const panels = Array.from(section.querySelectorAll('[data-rf-panel]'));
    const resultsBlocks = Array.from(section.querySelectorAll('[data-rf-results]'));
    const resultsProducts = section.querySelector('[data-rf-results-kind="products"]');
    const emptyState = section.querySelector('[data-rf-empty]');
    const toggleWrapProduct = section.querySelector('[data-rf-anti-wrap="product"]');
    const toggleInputProduct = section.querySelector('[data-rf-anti-toggle="product"]');
    const toggleHelpProduct = null;
    const antiStepLabel = section.querySelector('[data-rf-anti-step-label]');
    const antiToggleLabel = section.querySelector('[data-rf-anti-toggle-label]');
    const antiStepWrap = section.querySelector('[data-rf-anti-step]');
    const sticky = section.querySelector('[data-rf-sticky]');
    const stickyCurrent = sticky ? sticky.querySelector('[data-rf-sticky-current]') : null;
    const stickyPrice = sticky ? sticky.querySelector('[data-rf-sticky-price]') : null;
    const stickyCompare = sticky ? sticky.querySelector('[data-rf-sticky-compare]') : null;
    const stickyCta = sticky ? sticky.querySelector('[data-rf-sticky-cta]') : null;
    const skinTest = section.querySelector('[data-rf-skin-test]');
    const skinTestWrap = section.querySelector('[data-rf-skin-test-wrap]');
    const controls = section.querySelector('[data-rf-controls]');
    const controlsTitle = section.querySelector('[data-rf-controls-title]');
    const resetButton = section.querySelector('[data-rf-reset]');
    const introBreakpoint = window.matchMedia('(max-width: 767px)');

    const enableAnalytics = section.dataset.enableAnalytics === 'true';
    const enableSticky = section.dataset.enableSticky === 'true';

    let currentStep1 = section.dataset.defaultStep1 || '';
    let currentStep2 = section.dataset.defaultStep2 || '';
    let isPastControls = false;

    const pushEvent = (eventName, detail) => {
      if (!enableAnalytics) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        ...detail
      });
    };

    const getPanelMatch = (step1, step2, kind) =>
      panels.find((panel) => {
        const matches = panel.dataset.step1 === step1 && panel.dataset.step2 === step2;
        if (!matches) return false;
        if (!kind) return true;
        return panel.dataset.panelKind === kind;
      });

    const setResultsSwitching = () => {
      if (!resultsProducts) return;
      resultsProducts.classList.add('is-switching');
      window.setTimeout(() => resultsProducts.classList.remove('is-switching'), 220);
    };

    const updateStickyContent = (panel) => {
      if (!sticky || !panel) return;
      const activeBundleCard = getActiveBundleCard(panel, toggleInputProduct?.checked);
      const hasBundle = !!activeBundleCard;
      if (!hasBundle) {
        sticky.dataset.hasBundle = 'false';
        return;
      }
      const label = panel.dataset.panelLabel || '';
      const price = activeBundleCard.dataset.bundlePrice || '';
      const compare = activeBundleCard.dataset.bundleCompare || '';
      const url = activeBundleCard.dataset.bundleUrl || '#';
      sticky.dataset.hasBundle = 'true';
      if (stickyCurrent) stickyCurrent.textContent = label ? `: ${label}` : '';
      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyCompare) {
        if (compare) {
          stickyCompare.hidden = false;
          stickyCompare.textContent = compare;
        } else {
          stickyCompare.hidden = true;
          stickyCompare.textContent = '';
        }
      }
      if (stickyCta) stickyCta.setAttribute('href', url);
    };

    const updateStickyVisibility = () => {
      if (!sticky || !enableSticky) return;
      const hasBundle = sticky.dataset.hasBundle === 'true';
      const shouldShow = isPastControls && hasBundle;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle('routine-finder-sticky-open', shouldShow);
    };

    const panelHasAnti = (panel) => {
      if (!panel) return false;
      if (panel.dataset.antiAvailable === 'true') return true;
      return !!panel.querySelector('.routine-finder__product.is-anti');
    };

    const updateAntiState = (panel) => {
      if (!toggleInputProduct || !toggleWrapProduct || !panel) return;
      const hasAnti = panelHasAnti(panel);
      if (!hasAnti) {
        toggleInputProduct.checked = false;
        toggleInputProduct.disabled = true;
        toggleWrapProduct.classList.add('is-disabled');
        if (toggleHelpProduct) toggleHelpProduct.classList.add('is-visible');
        applyAntiToPanel(panel, false);
        return;
      }
      toggleInputProduct.disabled = false;
      toggleWrapProduct.classList.remove('is-disabled');
      if (toggleHelpProduct) toggleHelpProduct.classList.remove('is-visible');
      applyAntiToPanel(panel, toggleInputProduct.checked);
    };

    const updateAntiStepLabel = (panel) => {
      if (!antiStepLabel) return;
      const fallback = antiStepLabel.dataset.defaultLabel || '';
      const label = (panel && panel.dataset.antiStepLabel) || fallback;
      if (label) {
        antiStepLabel.textContent = label;
      }
    };

    const updateOptionalControls = (panel) => {
      let showAnti = false;
      if (antiStepWrap) {
        showAnti = !!(panel && panel.dataset.showAntiToggle === 'true');
        antiStepWrap.hidden = !showAnti;
        if (toggleInputProduct) {
          toggleInputProduct.checked = showAnti && panel ? panel.dataset.antiDefaultProduct === 'true' : false;
        }
        if (antiToggleLabel) {
          antiToggleLabel.textContent = (panel && panel.dataset.antiLabel) || antiToggleLabel.textContent;
        }
      }
      if (controlsTitle) {
        const label = showAnti ? controlsTitle.dataset.labelThree : controlsTitle.dataset.labelTwo;
        if (label) controlsTitle.textContent = label;
      }
      if (skinTest) {
        const url = panel ? panel.dataset.skinTestUrl || '' : '';
        const showSkin = panel && panel.dataset.showSkinTest === 'true' && !!url;
        skinTest.hidden = !showSkin;
        if (skinTestWrap) {
          skinTestWrap.hidden = !showSkin;
        }
        if (showSkin) {
          skinTest.textContent = panel.dataset.skinTestLabel || skinTest.dataset.defaultLabel || skinTest.textContent;
          skinTest.setAttribute('href', url);
        }
      }
    };

    const panelHasAntiBundle = (panel) => {
      if (!panel) return false;
      if (panel.dataset.antiBundleAvailable === 'true') return true;
      return !!panel.querySelector('.routine-finder__bundle-card.is-anti');
    };

    const getActiveBundleCard = (panel, isBundleAntiOn) => {
      if (!panel) return null;
      const antiCard = panel.querySelector('.routine-finder__bundle-card.is-anti');
      const defaultCard = panel.querySelector('.routine-finder__bundle-card.is-default');
      if (isBundleAntiOn && antiCard) return antiCard;
      if (!isBundleAntiOn && defaultCard) return defaultCard;
      return antiCard || defaultCard || null;
    };

    const applyBundleToPanel = (panel, enabled) => {
      const antiCard = panel.querySelector('.routine-finder__bundle-card.is-anti');
      const defaultCard = panel.querySelector('.routine-finder__bundle-card.is-default');
      if (defaultCard) defaultCard.hidden = enabled;
      if (antiCard) antiCard.hidden = !enabled;
    };

    const updateBundleState = (panel) => {
      if (!panel) return;
      const hasAntiBundle = panelHasAntiBundle(panel);
      if (!hasAntiBundle) {
        applyBundleToPanel(panel, false);
        return;
      }
      const enabled = toggleInputProduct ? toggleInputProduct.checked : false;
      applyBundleToPanel(panel, enabled);
    };

    const applyAntiToPanel = (panel, enabled) => {
      const slot = panel.dataset.antiSlot;
      if (!slot) return;
      let slotCard = panel.querySelector(`[data-step-slot="${slot}"]`);
      if (!slotCard) return;
      const defaultCard = slotCard.querySelector('.routine-finder__product.is-default');
      const antiCard = slotCard.querySelector('.routine-finder__product.is-anti');
      if (!defaultCard || !antiCard) return;
      defaultCard.hidden = enabled;
      antiCard.hidden = !enabled;
    };

    const updateIntroBulletState = (step1, step2, productPanel) => {
      const introPanel = getPanelMatch(step1, step2, 'intro');
      if (!introPanel) return;
      const bullet = introPanel.querySelector('[data-rf-bullet3]');
      if (!bullet) return;

      const defaultText = bullet.dataset.bulletDefault || '';
      const proText = bullet.dataset.bulletPro || '';
      const antiOn = toggleInputProduct ? toggleInputProduct.checked : false;
      const hasAnti = panelHasAnti(productPanel);
      const nextText = antiOn && hasAnti && proText ? proText : defaultText || proText;

      bullet.textContent = nextText;
      bullet.hidden = !nextText;
    };

    const setIntroExpanded = (introPanel, expanded) => {
      if (!introPanel) return;
      introPanel.classList.toggle('is-expanded', expanded);
      const toggle = introPanel.querySelector('[data-rf-why-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    };

    const syncIntroCollapseState = (step1, step2) => {
      const introPanelWrap = getPanelMatch(step1, step2, 'intro');
      const introPanel = introPanelWrap ? introPanelWrap.querySelector('[data-rf-intro-panel]') : null;
      if (!introPanel) return;
      setIntroExpanded(introPanel, !introBreakpoint.matches);
    };

    const setActivePanel = (step1, step2) => {
      const panel = getPanelMatch(step1, step2, 'products');
      panels.forEach((item) => {
        const isActive = item.dataset.step1 === step1 && item.dataset.step2 === step2;
        item.classList.toggle('is-active', isActive);
        item.hidden = !isActive;
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
      if (emptyState) {
        emptyState.hidden = !!panel;
      }
      if (panel) {
        updateOptionalControls(panel);
        updateAntiState(panel);
        updateBundleState(panel);
        updateStickyContent(panel);
        updateAntiStepLabel(panel);
        updateIntroBulletState(step1, step2, panel);
        syncIntroCollapseState(step1, step2);
      } else {
        updateOptionalControls(null);
        updateAntiStepLabel(null);
        updateIntroBulletState(step1, step2, null);
      }
      setResultsSwitching();
    };

    const setActiveStep2 = (step1, step2, isInit) => {
      currentStep1 = step1;
      currentStep2 = step2;
      step2Buttons.forEach((btn) => {
        const matches = btn.dataset.rfStep1 === step1 && btn.dataset.rfStep2 === step2;
        btn.classList.toggle('is-active', matches);
        btn.setAttribute('aria-pressed', matches ? 'true' : 'false');
      });
      setActivePanel(step1, step2);
      updateStickyVisibility();
      if (!isInit) {
        pushEvent('Step2_select', { step1, step2 });
      }
    };

    const getFirstStep2 = (step1) => {
      const button = step2Buttons.find((btn) => btn.dataset.rfStep1 === step1 && !btn.hidden);
      return button ? button.dataset.rfStep2 : '';
    };

    const setActiveStep1 = (step1, isInit) => {
      currentStep1 = step1;
      step1Buttons.forEach((btn) => {
        const matches = btn.dataset.rfStep1 === step1;
        btn.classList.toggle('is-active', matches);
        btn.setAttribute('aria-pressed', matches ? 'true' : 'false');
      });
      step2Buttons.forEach((btn) => {
        btn.hidden = btn.dataset.rfStep1 !== step1;
      });
      const nextStep2 =
        (currentStep2 && getPanelMatch(step1, currentStep2) && currentStep2) || getFirstStep2(step1);
      setActiveStep2(step1, nextStep2, isInit);
      if (!isInit) {
        pushEvent('Step1_select', { step1 });
      }
    };

    const resetSelection = () => {
      const defaultStep1 = section.dataset.defaultStep1 || currentStep1 || '';
      const defaultStep2 = section.dataset.defaultStep2 || '';
      if (!defaultStep1) return;

      setActiveStep1(defaultStep1, true);
      const hasDefaultStep2 = defaultStep2 && getPanelMatch(defaultStep1, defaultStep2);
      if (hasDefaultStep2) {
        setActiveStep2(defaultStep1, defaultStep2, true);
      }
    };

    step1Buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        setActiveStep1(btn.dataset.rfStep1, false);
      });
    });

    step2Buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        setActiveStep2(btn.dataset.rfStep1, btn.dataset.rfStep2, false);
      });
    });

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        resetSelection();
      });
    }

      if (toggleInputProduct) {
        toggleInputProduct.addEventListener('change', () => {
          const panel = getPanelMatch(currentStep1, currentStep2, 'products');
          updateAntiState(panel);
          updateBundleState(panel);
          updateStickyContent(panel);
          updateIntroBulletState(currentStep1, currentStep2, panel);
          pushEvent('Toggle_antiaging', {
            step1: currentStep1,
            step2: currentStep2,
            state: toggleInputProduct.checked ? 'on' : 'off'
          });
        });
      }

      // Bundle state follows the anti-aging product toggle.

    if (skinTest) {
      skinTest.addEventListener('click', () => {
        pushEvent('Click_skin_test', { step1: currentStep1, step2: currentStep2 });
      });
    }

    section.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const whyToggle = target.closest('[data-rf-why-toggle]');
      if (whyToggle) {
        const introPanel = whyToggle.closest('[data-rf-intro-panel]');
        const shouldExpand = introPanel ? !introPanel.classList.contains('is-expanded') : false;
        setIntroExpanded(introPanel, shouldExpand);
        return;
      }

      const atc = target.closest('.product-card__atc');
      if (atc) {
        const productWrap = atc.closest('.routine-finder__product');
        if (!productWrap) return;
        pushEvent('Add_to_cart_single', {
          step1: currentStep1,
          step2: currentStep2,
          product_handle: productWrap.dataset.productHandle || '',
          variant_id: productWrap.dataset.variantId || ''
        });
      }

        const bundleCta = target.closest('[data-rf-bundle-cta]');
        const stickyCtaClicked = target.closest('[data-rf-sticky-cta]');
        if (bundleCta || stickyCtaClicked) {
          const panel = getPanelMatch(currentStep1, currentStep2, 'products');
          if (!panel) return;
          const activeBundleCard = getActiveBundleCard(panel, toggleInputProduct?.checked);
          const handle = activeBundleCard?.dataset.bundleHandle || panel.dataset.bundleHandle || '';
          const variant = activeBundleCard?.dataset.bundleVariant || panel.dataset.bundleVariant || '';
          pushEvent('Add_to_cart_bundle', {
            step1: currentStep1,
            step2: currentStep2,
            routine_id: panel.dataset.routineId || '',
            product_handle: handle,
            variant_id: variant
          });
        }
      });

    if (enableSticky && sticky && controls) {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              isPastControls = !entry.isIntersecting;
              updateStickyVisibility();
            });
          },
          { rootMargin: '-80px 0px 0px 0px', threshold: 0 }
        );
        observer.observe(controls);
      } else {
        window.addEventListener('scroll', () => {
          const rect = controls.getBoundingClientRect();
          isPastControls = rect.bottom < 0;
          updateStickyVisibility();
        });
      }
    }

    if (introBreakpoint.addEventListener) {
      introBreakpoint.addEventListener('change', () => {
        syncIntroCollapseState(currentStep1, currentStep2);
      });
    } else if (introBreakpoint.addListener) {
      introBreakpoint.addListener(() => {
        syncIntroCollapseState(currentStep1, currentStep2);
      });
    }

    const firstStep1 =
      (step1Buttons.find((btn) => btn.classList.contains('is-active')) || {}).dataset?.rfStep1 ||
      (step1Buttons.find((btn) => !btn.disabled) || {}).dataset?.rfStep1 ||
      '';
    const firstStep2 =
      (step2Buttons.find((btn) => btn.classList.contains('is-active')) || {}).dataset?.rfStep2 ||
      getFirstStep2(firstStep1);

    if (firstStep1) {
      setActiveStep1(firstStep1, true);
      if (firstStep2) {
        setActiveStep2(firstStep1, firstStep2, true);
      }
    }

    section.classList.add('is-js-ready');
  };

  const initAll = (scope) => {
    const root = scope || document;
    const sections = root.querySelectorAll('.routine-finder');
    sections.forEach((section) => initRoutineFinder(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
